module.exports = __webpack_public_path__ + "yemen.svg?54afdda46d916e85df6704a16946be2c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/yemen.svg
// module id = 342
// module chunks = 10